const apiImagePrefix = '/api/images/';
const apiFilePrefix = '/api/files/';

export const getImageUrl = (id) => apiImagePrefix + id;
export const getFileUrl = (id) => apiFilePrefix + id;
export const fetchFromApi = (url, options) => fetch(`/api/${url}`, options);

export const getImageIdFromUrl = (url) => ((url && url.startsWith(apiImagePrefix)) ? url.replace(apiImagePrefix, '') : url);
export const getFileIdFromUrl = (url) => ((url && url.startsWith(apiFilePrefix)) ? url.replace(apiFilePrefix, '') : url);

export const handleDownload = (file) => {
	const link = document.createElement('a');
	link.href = getImageUrl(file.id);
	link.download = file.filename; // desired file name
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
};

export const handleFileDownload = (file) => {
	const link = document.createElement('a');
	link.href = getFileUrl(file.id);
	link.download = file.filename; // desired file name
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
};
